import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth20deleteDeleteScreenTruthGrantsIdResponseSchema = jsonObject
export type tcpscreentruth20deleteDeleteScreenTruthGrantsIdResponse = z.infer<typeof tcpscreentruth20deleteDeleteScreenTruthGrantsIdResponseSchema>
